export default (item) => {
    let fullname = []
    if(item.name){
      fullname.push(item.name)
    }
    if(item.lastname){
      fullname.push(item.lastname)
    }
    if(item.lastname2){
      fullname.push(item.lastname2)
    }
    let string = fullname.join(" ")
    string = string.toLowerCase().replace(/\b[a-z]/g, function(letter) {
        return letter.toUpperCase();
    });
    return string
  }



// WEBPACK FOOTER //
// ./src/filters/formatFullName.js